<template>
  <main class="m-xs-3 m-sm-3 m-md-5 m-lg-5 m-xl-5">
    <div class="row">
      <div class="col-sm-4 col-md-3 col-lg-3 col-xl-3">
        <div class="custom-badge rounded-pill">
          <span class="d-xs-inline d-sm-inline d-md-block d-lg-block d-xl-block"
            >Status</span
          >
        </div>
      </div>
      <div
        class="content-area col-sm-8 col-md-9 col-lg-9 col-xl-9 py-lg-4 py-xl-4"
      >
        <section
          class="d-flex justify-content-between mb-4 rounded-pill border border-dark"
        >
          <div
            class="d-flex flex-row-reverse bg-dark rounded-pill px-2 py-1"
            style="width: 40%;"
          >
            <div
              class="bg-white rounded-circle d-flex align-items-center justify-content-center"
              style="width: 20px; height: 20px"
            >
              ✓
            </div>
          </div>
          <div
            class="bg-white rounded-circle border border-dark mr-4 my-1"
            style="width: 20px; height: 20px"
          ></div>
        </section>
        <section class="shipment-details d-flex justify-content-between w-100">
          <div class="d-flex justify-content-around">
            <div>
              <div class="font-weight-bold mb-1">Ordered (#101)</div>
              <div class="mb-2">23/5/2020</div>
              <div>12:45PM</div>
            </div>
            <div>
              <div class="font-weight-bold mb-1">Process</div>
              <div class="mb-1">Processing or ready</div>
              <div>23/5/2020</div>
            </div>
            <div>
              <div class="font-weight-bold mb-1">Shipped</div>
              <div class="mb-2">23/5/2020</div>
              <div>10:30PM</div>
            </div>
          </div>
          <div class="text-right">
            <div class="font-weight-bold mb-1">
              Estimated
              <br />Arrival
            </div>
            <div>6/6/2020</div>
          </div>
        </section>
      </div>
    </div>
    <div class="row">
      <div
        class="d-flex flex-xl-column flex-lg-column flex-md-column flex-sm-column flex-xs-row col-sm-4 align-items-sm-start align-items-xs-start col-md-3 col-lg-3 col-xl-3"
      >
        <div class="custom-badge rounded-pill">
          <span class="d-xs-inline d-sm-inline d-md-block d-lg-block d-xl-block"
            >Location Update</span
          >
        </div>
        <div
          class="location-update d-flex flex-md-column flex-lg-column flex-xl-column flex-sm-row flex-xs-row align-items-center mx-auto font-weight-bold"
        >
          <div class="text-center d-flex justify-content-between">
            <span>Real Time</span>
            <span>
              <svg
                width="2.5em"
                height="1em"
                viewBox="0 0 16 16"
                class="bi bi-arrow-down-short"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"
                />
              </svg>
            </span>
          </div>
          <div class="text-center d-flex justify-content-between">
            <span>Updated</span>
            <span>
              <svg
                width="2.5em"
                height="1em"
                viewBox="0 0 16 16"
                class="bi bi-arrow-down-short"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
      <div
        class="content-area col-sm-8 col-md-9 col-lg-9 col-xl-9 py-lg-4 py-xl-4"
      >
        <section
          class="mb-4 rounded-pill border border-dark d-flex justify-content-between"
        >
          <div
            class="d-flex flex-row-reverse bg-dark rounded-pill px-2 py-1"
            style="width: 40%;"
          >
            <div
              class="bg-white rounded-circle d-flex align-items-center justify-content-center"
              style="width: 20px; height: 20px"
            >
              ✓
            </div>
          </div>
          <div
            class="bg-white rounded-circle border border-dark mr-4 my-1"
            style="width: 20px; height: 20px"
          ></div>
        </section>
        <section class="shipment-details d-flex justify-content-between w-100">
          <div class="d-flex justify-content-around">
            <div>
              <div class="font-weight-bold mb-1">Origination (#100)</div>
              <div class="mb-2">Gombe, Nigeria</div>
              <div>12:45PM</div>
            </div>
            <div>
              <div class="font-weight-bold mb-1">Transit</div>
              <div class="mb-2">Niger, Nigeria</div>
              <div>23/5/2020</div>
            </div>
            <div>
              <div class="font-weight-bold mb-1">Transit</div>
              <div class="mb-2">Akure, Nigeria</div>
              <div>23/5/2020</div>
            </div>
          </div>
          <div class="text-right">
            <div class="mb-1 font-weight-bold">Arrived</div>
            <div class="mb-2">Lagos, Nigeria</div>
            <div>23/5/2020</div>
          </div>
        </section>
        <div class="d-flex align-item-center justify-content-center mt-4">
          <div
            class="d-flex align-item-center justify-content-center"
            style="cursor:pointer"
          >
            <svg
              width="2em"
              height="2em"
              viewBox="0 0 16 16"
              class="bi bi-arrow-down-circle"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
              />
              <path
                fill-rule="evenodd"
                d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4 col-md-3 col-lg-3 col-xl-3">
        <div class="custom-badge rounded-pill">
          <span class="d-xs-inline d-sm-inline d-md-block d-lg-block d-xl-block"
            >Documentation</span
          >
        </div>
      </div>
      <div
        class="content-area col-sm-8 col-md-9 col-lg-9 col-xl-9 py-lg-4 py-xl-4"
      >
        <section class="mb-4"></section>
        <section
          class="documentation-details d-flex justify-content-between w-100"
        >
          <div class="d-flex">
            <div class="pill-wrapper">
              <div class="font-weight-bold mb-1">Way Bill</div>
              <div class="mb-4">12:45PM</div>
              <div
                @click="showModal = true"
                class="documentation-view rounded-pill border border-dark text-center py-1 w-50 mx-auto"
              >
                View
              </div>
            </div>
            <div class="pill-wrapper">
              <div class="font-weight-bold mb-1">QL Produce Cert</div>
              <div class="mb-4">23/5/2020</div>
              <div
                @click="showModal = true"
                class="documentation-view rounded-pill border border-dark text-center py-1 w-50 mx-auto"
              >
                View
              </div>
            </div>
            <div class="pill-wrapper">
              <div class="font-weight-bold mb-1">Receipt</div>
              <div class="mb-4">23/5/2020</div>
              <div
                @click="showModal = true"
                class="documentation-view rounded-pill border border-dark text-center py-1 w-50 mx-auto"
              >
                View
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <modal-views v-if="showModal">
      <div slot="modal" class="modal-view">
        <div @click="showModal = false" class="d-flex flex-row-reverse">
          <svg
            width="2em"
            height="2em"
            viewBox="0 0 16 16"
            class="bi bi-x"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </div>
        <div class="pt-4">
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Magnam
          voluptatibus provident, voluptatum id velit cum doloremque eos ab,
          eligendi labore quis alias, obcaecati cumque maiores quod delectus
          facere soluta perspiciatis
        </div>
      </div>
    </modal-views>
  </main>
</template>

<script>
export default {
  name: "Shipment",
  data() {
    return {
      showModal: false
    };
  },
  components: {
    ModalViews: () => import("./layout/modals/modal")
  }
};
</script>

<style scoped>
.custom-badge {
  display: inline-block;
  width: 80%;
  background: #fff;
  padding: 1rem 0.8rem;
  border: 1px solid #000;
  color: #000;
  text-align: center;
}

.shipment-details > div:nth-child(1),
.documentation-details > div {
  width: 60%;
  text-align: center;
}

.shipment-details > div:nth-child(2) {
  width: 40%;
}

.content-area {
  background: rgba(148, 200, 31, 0.05);
  border: none;
  padding: 5px;
}

.pill-wrapper {
  width: calc(100% / 3);
}

.documentation-view {
  font-size: 0.8rem;
  cursor: pointer;
}

.location-update {
  width: 65%;
  margin-top: 5%;
}

.location-update div {
  margin: 3% 0;
}

.modal-view {
  width: 30%;
  background: #fff;
  padding: 2%;
  border-radius: 7px;
}

.modal-view div:nth-child(1) {
  cursor: pointer;
}

@media only screen and (max-width: 820px) {
  .documentation-details > div {
    width: 100%;
  }

  .custom-badge {
    width: 80%;
  }

  .location-update {
    width: 100%;
    font-size: 0.7rem;
  }

  .modal-view {
    width: 50%;
  }
}

@media only screen and (max-width: 540px) {
  .custom-badge {
    display: block;
    width: 40%;
    padding: 0.5rem;
    margin: 15% 0 5% 0;
  }

  .shipment-details > div:nth-child(1) {
    width: 100%;
  }

  .shipment-details > div:nth-child(2) {
    width: 30%;
  }

  .shipment-details {
    font-size: 0.7rem;
    padding: 0 0.7rem 0 0;
  }

  .location-update {
    width: 50%;
    font-size: 0.7rem;
    margin-bottom: 5%;
    padding-top: 15%;
  }

  .modal-view {
    width: 85%;
    padding: 5%;
  }
}
</style>
